import {CREDIT_CARD_VISA, CREDIT_CARD_AMERICAN_EXPRESS, CREDIT_CARD_MASTERCARD, CREDIT_CARD_JCB, CREDIT_CARD_DISCOVER, CREDIT_CARD_DINERS_CLUB} from './constants'

export function validator(cardNumber){
    const cardArray = cardNumber.toString().split("").map((e) => parseInt(e) )
      validlen(cardArray);
      const splitArr =  arrSplit(cardArray)
      let checksum;
      if (splitArr.arr1.length > 0 && splitArr.arr2.length > 0) {
        checksum = sumArrDigits(splitArr.arr1).reduce((a, c) => a + c) + splitArr.arr2.reduce((a, c) => a + c);
      }

      const typeValidatorArr = cardArray.slice(0,2)
      const typeValidatorInt = parseInt(typeValidatorArr.join(""))
      if (typeValidatorArr[0] == 4){
        return CREDIT_CARD_VISA
      }else if(typeValidatorInt == 34 || typeValidatorInt == 37){
        return CREDIT_CARD_AMERICAN_EXPRESS;
      }else if(typeValidatorInt == 22 || typeValidatorInt == 51 || typeValidatorInt == 52 || typeValidatorInt == 53 || typeValidatorInt == 54 || typeValidatorInt == 55){
        return CREDIT_CARD_MASTERCARD;
      }else if(typeValidatorInt == 35 ){
        return CREDIT_CARD_JCB;
      }else if(typeValidatorInt == 60 ){
        return CREDIT_CARD_DISCOVER;
      }else if(typeValidatorInt == 30 ){
        return CREDIT_CARD_DINERS_CLUB;
      }
    }
    
    function sumArrDigits(array){
      return array.join("").split("").map(e => parseInt(e))
    }

    export function validlen(array) {
      // checks for card length of 13, 15, 16 or 18
      return array.length == 13  || array.length == 15 || array.length == 16 || array.length == 18;
    }
    
    function arrSplit(cardArray){
      const selectOddValues = cardArray.filter((a,i)=>i%2 === 1);
      const selectEvenValues = cardArray.filter((a,i)=>i%2 === 0);
      let arr1;
      let arr2;
      if (cardArray.length % 2 == 1){
        arr1 = selectOddValues.map(e => e * 2);
        arr2 = selectEvenValues;
      }else {
        arr1 = selectEvenValues.map(e => e * 2);
        arr2 = selectOddValues;
      }
      return {arr1, arr2}
    }


// WEBPACK FOOTER //
// ./src/payments/ClaroPagosGate/cardValidator.js